import $ from 'jquery';
const backTopBtn = $('#back-top');
const doc = $('html,body');
const $window = $(window);

// 防抖
function debounce(fn) {
    return () => window.requestAnimationFrame(fn);
}

window.addEventListener('scroll', debounce(() => {
    const top = $window.scrollTop();
    if (top >= $window.height()) {
        backTopBtn.fadeIn();
    } else {
        backTopBtn.fadeOut();
    }
}));

backTopBtn.click(() => {
    doc.animate({
        scrollTop: 0,
    }, 500);
});